import { Autocomplete, Box, Button, CircularProgress, FormControl, FormHelperText, Grid, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, set, useForm } from 'react-hook-form'
import { DesktopDatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BookingService } from '../Service';
import Swal from 'sweetalert2';
import { BookingDataContext, StepperDataContext } from './AddBooking';

const BookingSchedule = () => {
  const { bookingInitiationData, dateTimeSlot, setDateTimeSlot, selectedCart, setBookingInProgressData } = useContext(BookingDataContext);
  const { activeStep, handleNext, handleBack, handleComplete } = useContext(StepperDataContext);
  const { control, handleSubmit, setValue, formState: { errors, isDirty }, watch, reset } = useForm({
    mode: "onChange",
    defaultValues: {
      serviceDate: '',
      timeSlot: '',
    }
    // {
    //   ...dateTimeSlot
    // }
  });

  const [loadingTimeSlotList, setLoadingTimeSlotList] = useState(false);
  const [timeSlotList, setTimeSlotList] = useState([]);

  const selectedDate = watch('serviceDate');

  // Add this new useEffect to sync form with bookingInitiationData
  // useEffect(() => {
  //   reset({
  //     ...dateTimeSlot
  //   },{isDirty:false});
  // }, [bookingInitiationData,dateTimeSlot, reset]);
  useEffect(()=>{
    if(dateTimeSlot.serviceDate){
      // reset({
      //   ...dateTimeSlot
      // },{isDirty:false});
      setValue('serviceDate',dateTimeSlot.serviceDate,{ shouldDirty: true });
      setValue('timeSlot',dateTimeSlot.timeSlot,{ shouldDirty: true });
    }
  },[])
  useEffect(() => {
    // setValue('serviceDate',selectedDate);
    if (selectedDate && selectedCart && bookingInitiationData?.bookingId) {
      // console.log("selected Date:",selectedDate)
      // if(!dateTimeSlot.timeSlot || dateTimeSlot.serviceDate!==selectedDate){
      //   setValue('timeSlot','')
      // }else{
      //   setValue('timeSlot',dateTimeSlot.timeSlot)
      // }
      // setValue('timeSlot', '')
      const fetchTimeSlots = async () => {
        setLoadingTimeSlotList(true);
        // console.log("required data for getting time slot:",data);
        try {
          const timeSlotResponse = await BookingService.fetchProviderTimeSlot({
            "bookingId": bookingInitiationData?.bookingId,
            "timeSlotDate": selectedDate,
          });
          // console.log("Time slot Response:",timeSlotResponse);
          if (timeSlotResponse.success == "1") {
            if (timeSlotResponse?.data.length > 0) {
              setTimeSlotList(timeSlotResponse.data);
            } else {
              Swal.fire('Time Slot for selected Date not available', '', 'error');
              setValue('serviceDate', '')
            }

          } else {
            Swal.fire(timeSlotResponse.message, '', 'error');
          }
        } catch (error) {

        } finally {
          setLoadingTimeSlotList(false);
        }
      }
      fetchTimeSlots();
    }
  }, [selectedDate])

  const [isFormSubmitting, setIsFormSubmitting] = useState(false);

  const completeStep3 = async (data) => {
    setIsFormSubmitting(true);
    const timeJson = JSON.parse(data?.timeSlot);
    Swal.fire({
      // title: cartServiceModification ? 'Updating Cart' : 'Please wait While fetching slot',
      title: 'Please wait While updating time slot',
      // html: 'Please wait',
      timerProgressBar: true,
      didOpen: () => {
          Swal.showLoading();
      },
    });
    const timeSlotUpdateResponse = await BookingService.updatebookingTimeSlot({
      "bookingId": bookingInitiationData?.bookingId,
      "timeSlotDate": data.serviceDate,
      "startTime": timeJson.startTime,
      "endTime": timeJson.endTime,
      "useCoin": true
    })
    if (timeSlotUpdateResponse.success == "1") {
      // setBookingInProgressData(timeSlotUpdateResponse.data);
      const bookingDetails = await BookingService.bookingDetailById(bookingInitiationData?.bookingId)
      setBookingInProgressData(bookingDetails.data);
      setDateTimeSlot({
        serviceDate: data.serviceDate,
        timeSlot: data.timeSlot
      });
      // handleComplete();
      
      Swal.close();
      handleNext();
    } else if (timeSlotUpdateResponse.success == "0") {
      Swal.fire(timeSlotUpdateResponse.message, '', 'error');
      setIsFormSubmitting(false);      
    }

  }
  return (
    <Box component={'form'} onSubmit={handleSubmit(completeStep3)} sx={{ pb: '1%' }}>
      <Grid container spacing={2} >
        <Grid item lg={9} xs={12} sx={{margin:'auto'}}>
          <Grid container spacing={1} >
            {/* ............left section................... */}
            <Grid item xs={12} sm={6} md={5}>
              <Grid container>
                <Grid item xs={12} sx={{ my: '1%' }}>
                  <Grid container sx={{ mb: '1%' }}>
                    <Grid item lg={7} xs={12}>
                      <Typography sx={{ fontWeight: '600', fontSize: '0.85rem', fontFamily: 'Poppins' }}>Select Date<span style={{ color: '#d32f2f' }}>*</span></Typography>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={'12'}>
                      <Controller
                        name="serviceDate"
                        control={control}
                        rules={{
                          validate: (value) => {
                            if (!value) return "This field is required";
                            const date = dayjs(value);
                            const today = dayjs().startOf('day');
                            return date.isValid() && (date.isSame(today, 'day') || date.isAfter(today)) || "Booking Date must be today or in the future";
                          }
                        }}
                        render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                              {...restField}
                              sx={{
                                '& . iconButton': {
                                  padding: 0.5,
                                  fontSize: '1rem'
                                }
                              }}
                              // disabled={!watch('services').length>0 || !watch('customer')}
                              value={value ? dayjs(value) : null}
                              onChange={(newValue) => {
                                // Store the date in YYYY-MM-DD format for database compatibility
                                onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                              }}
                              format="DD-MM-YYYY" // Display format for user
                              minDate={dayjs()}
                              slotProps={{
                                textField: {
                                  error: !!error,
                                  helperText: error?.message,
                                  fullWidth: true,
                                  required: true,
                                  size: 'small',
                                  inputProps: {
                                    style: { fontSize: '.75rem' }
                                  }
                                }
                              }}
                            />
                          </LocalizationProvider>
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* ............central gap................... */}
            <Grid item md={2} sx={{ display: { xs: 'none', md: 'block' } }}>

            </Grid>
            {/* ............right section................... */}
            <Grid item xs={12} sm={6} md={5}>
              <Grid container>
                <Grid item xs={12} >
                  <Grid container sx={{ mb: '1%' }}>
                    <Grid item lg={7} xs={12}>
                      <Typography sx={{ fontWeight: '600', fontSize: '0.85rem', fontFamily: 'Poppins' }}>Select Time Slot<span style={{ color: '#d32f2f' }}>*</span></Typography>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={loadingTimeSlotList ? '10' : '12'} >

                      <Controller
                        name="timeSlot"
                        control={control}
                        rules={{
                          required: 'Please select a time slot',
                        }}
                        render={({ field, fieldState: { error } }) => (
                          <FormControl error={!!error} fullWidth>
                            <Autocomplete
                              id="time-slot-autocomplete"
                              options={timeSlotList}
                              // sx={{
                              //   display: services.length > 0 ? 'block' : 'none',
                              // }}
                              disabled={!watch('serviceDate') || !bookingInitiationData.customer}
                              getOptionLabel={(option) => {
                                // Handle both string (from field value) and object (from options) cases
                                // const slot = typeof option === 'string' ? JSON.parse(option) : option;
                                return `${dayjs(option.startTime, 'HH:mm:ss').format('h:mm A')} - ${dayjs(option.endTime, 'HH:mm:ss').format('h:mm A')}`;
                              }}
                              isOptionEqualToValue={(option, value) => {
                                // Handle both string and object cases for comparison
                                const valueObj = typeof value === 'string' ? JSON.parse(value) : value;
                                return option.startTime === valueObj.startTime && option.endTime === valueObj.endTime;
                              }}
                              value={field.value ? (typeof field.value === 'string' ? JSON.parse(field.value) : field.value) : null}
                              onChange={(_, newValue) => {
                                field.onChange(newValue ? JSON.stringify(newValue) : null);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  InputProps={{
                                    ...params.InputProps,
                                    style: { fontSize: '0.75rem', color: '#000' },
                                  }}
                                  placeholder="Select Time Slot"
                                  variant="outlined"
                                  error={!!error}
                                  size="small"
                                />
                              )}
                              ListboxProps={{
                                sx: {
                                  '& .MuiAutocomplete-option': {
                                    padding: '8px 16px',
                                    fontSize: '0.75rem',
                                    '&:hover': {
                                      backgroundColor: '#f5f5f5',
                                    },
                                  },
                                },
                              }}
                            />
                            {error && <FormHelperText>{error.message}</FormHelperText>}
                          </FormControl>
                        )}
                      />
                    </Grid>

                    {loadingTimeSlotList && <Grid item xs={2}><CircularProgress size={30}/></Grid>}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* ............right section ends................... */}
          </Grid>
        </Grid>
      </Grid>
      {/* =======Form Action Button Section ========*/}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: '.5%' }}>
        <Button size='small' sx={{textTransform:'none'}} disabled={isFormSubmitting} onClick={handleBack} variant='contained' color='secondary'>Back</Button>
        <Button size='small' sx={{textTransform:'none'}} disabled={!isDirty || isFormSubmitting}
          type='submit'
          // onClick={handleNext}
          variant='contained' color='primary'>{isFormSubmitting ? 'Please Wait....' : 'Submit & Next'}</Button>
      </Box>
    </Box>
  );
}

export default BookingSchedule;
